// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "vendors-constructor") return "" + chunkId + ".js";
  // return url for filenames based on template
  return "" + chunkId + ".js?v=" + {"admind-cart": "2a50d","blog-scrollbar": "82e66","footer-widgets": "00483","form-validation": "2e95d","frame-blocks": "c39e5","lazy-bg-image": "7866b","product-section": "5b1fc","quick-search": "c8100","quick-view": "367a0","recently-viewed": "6a30e","recommendations": "a973c",}[chunkId] + ""
}